<div class="slider">
  <div class="slider__range">
    <input
      type="range"
      class="range"
      [class.light]="theme === 'light'"
      [class.dark]="theme === 'dark'"
      [(ngModel)]="value"
      [min]="min"
      [max]="max"
      [step]="step"
      [disabled]="disabled"
      (dblclick)="handleRangeDoubleClick()"
      (mouseup)="handleMouseUp()"
      [attr.aria-label]="label" />
  </div>

  <div class="slider__input">
    <input
      type="number"
      class="input"
      [(ngModel)]="value"
      [min]="min"
      [max]="max"
      [step]="step"
      [disabled]="disabled"
      (blur)="handleBlur()"
      [attr.aria-label]="label" />
  </div>
</div>
